import { types, Instance } from 'mobx-state-tree';

export const Resource = types
  .model('Resource', {
    assessmentKey: types.string,
    header: types.maybeNull(types.string),
    description: types.maybeNull(types.string),
  })
  .views((self) => ({}))
  .actions((self) => ({
    setHeader: (header: string) => {
      self.header = header;
    },
    setDetails: (details: string) => {
      self.description = details;
    },
  }));

export default Resource;

export interface IResource extends Instance<typeof Resource> { }
